import { render, staticRenderFns } from "./PersonalInfoDisplayWidget.vue?vue&type=template&id=39c69e4c&scoped=true&"
import script from "./PersonalInfoDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoDisplayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c69e4c",
  null
  
)

export default component.exports